export default __webpack_public_path__ + "images/9852ef90d83ae10d906cbb1521512e15.png";